import { useUserStore } from 'hooks/stores/useUserStore';
import Link from 'next/link';
import { useEffect } from 'react';
import { track_links } from 'utils/analytics/analytics';
import { ASSET_PREFIX, colors } from 'utils/constants';
import { FooterLink } from './FooterLink';
import { PaymentLogoSection } from './PaymentLogoSection';
import { SignupNewsletter } from './SignupNewsletter';
import { SocialLinkSection } from './SocialLinkSection';
import { TrustIconSection } from './TrustIconSection';

const Footer = () => {
  const { currentUser, subscriptions } = useUserStore();

  const faqLink =
    currentUser?.id &&
    subscriptions.find(
      (s) =>
        s.subscription.status === 'ACTIVE' ||
        s.subscription.status === 'SNOOZED' ||
        s.subscription.status === 'FAILING',
    )
      ? 'https://daymade.zendesk.com/hc/en-gb'
      : '/faq';

  useEffect(() => {
    track_links('#facebookext', 'Clicked Facebook link');
    track_links('#instagramext', 'Clicked Instagram link');
    track_links('#youtubeext', 'Clicked Youtube link');
    track_links('#tiktokext', 'Clicked Tiktok link');
    track_links('#faqlink', 'Clicked FAQ link');
    track_links('#contactuslink', 'Clicked Contact us link');
  }, []);

  return (
    <footer
      className="w-full p-5 flex justify-center"
      style={{ backgroundColor: colors.footerBackground }}
    >
      <div className="w-full max-w-[1200px] grid grid-cols-1 gap-8 my-4">
        <div className=" w-full grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0">
          <div className="w-full flex flex-col justify-center items-center md:items-start ">
            <Link href="/">
              <img
                className="cursor-pointer w-[150px] md:w-[200px]"
                src={`${ASSET_PREFIX}/images/daymade-logo.png`}
                alt="DAYMADE logo"
              />
            </Link>
          </div>
          <div className="flex">
            <SocialLinkSection />
          </div>
          <div className="flex justify-center md:justify-end">
            <PaymentLogoSection />
          </div>
        </div>

        <div className="separator !m-0 !w-full" />

        <div className=" w-full h-full grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-0">
          <div className="w-full flex flex-col justify-between md:items-start gap-4">
            <FooterLink link={'/about-us'} text={'About Us'} />
            <FooterLink link={'/how-it-works'} text={'How It Works'} />
            <FooterLink text={'FAQ'} link={faqLink} id={'faqlink'} />
            <FooterLink link={'/contact-us'} text={'Contact Us'} />
          </div>
          <div className="w-full flex flex-col justify-between md:items-start gap-4 ">
            <FooterLink link={'/blog'} text={'Blog'} />
            <FooterLink link={'/responsible-play'} text={'Responsible Play'} />
            <FooterLink
              link={'/terms-and-conditions'}
              text={'Terms & Conditions'}
            />
            <FooterLink link={'/privacy-policy'} text={'Privacy Policy'} />

            {/* We need an extra element to balance the footer link columns on desktop devices. The footer links
            are spread evenly across the footer's height using flexbox, so we can align them to the top of the
            container*/}
            {/* <br className="extraFooterLink" /> */}
          </div>
          <div className="hidden md:flex justify-center md:justify-end">
            <SignupNewsletter />
          </div>
        </div>
        <div className="flex md:hidden separator !m-0 !w-full" />

        <div className="flex md:hidden justify-center">
          <SignupNewsletter />
        </div>

        <div className="separator !m-0 !w-full" />

        <div className="w-full grid grid-cols-1">
          <TrustIconSection />
        </div>

        <div className="separator !m-0 !w-full" />

        <div className="w-full  grid grid-cols-1">
          <div
            data-nosnippet
            style={{ fontWeight: 600, textAlign: 'center' }}
            className="text-centered"
          >
            DAYMADE is an associated brand of, and operated by, DAYMADE LTD
            (registered in England & Wales, company number 12333770).
            <br />
            <br />
            Please note that DAYMADE is an operator of prize draws. Our online
            contests to win prizes include a method of entry via post. No
            purchase is necessary to enter but the intention of the draws is
            that people enter to win prizes and support a worthy charitable
            cause.
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .extraFooterLink {
            display: none;
          }
          @media (min-width: 768px) {
            .extraFooterLink {
              display: block;
            }
          }
        `}
      </style>
    </footer>
  );
};

export default Footer;
